import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  confirmDisable() {
    if (!this.checkboxTarget.checked) {
      const confirmed = confirm(
        "Turning off retention tracking will stop comparing future uploads against previous ones. " +
        "Your existing retention data will be preserved.\n\n" +
        "Are you sure?"
      )
      if (!confirmed) {
        this.checkboxTarget.checked = true
      }
    }
  }
}
